import { defineAsyncComponent } from 'vue'
export default {
  "404": defineAsyncComponent(() => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/layouts/404.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/layouts/default.vue").then(m => m.default || m)),
  "surfsup-layout": defineAsyncComponent(() => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/layouts/surfsup-layout.vue").then(m => m.default || m))
}